import React from "react";
import styled from "styled-components/native";

import { Animated } from "react-native";
import { DrawerContentScrollView,} from '@react-navigation/drawer';

import { View } from "~/native-ui/native-base"
import { ClipView } from "~/native-ui/AnimatedView"
import { animationRef, useDrawerAnimationContext } from "~/native-ui/Navigation/DrawerAnimationContext";
import { navigationService } from ".";
import { withResponsiveFlags } from "../../hoc/withResponsiveProps";

const StyledAnimatedView = styled(ClipView)`
    backgroundColor: white;
    height: 100vh;
`



const StyledView = styled(View)`
    height: 100vh;
    filter: drop-shadow(#d8d8d8 1px 0px 0px);
`

const DrawerContent = ({ showDrawer, ...props }) => {
    const {animation, drawerStyle} = useDrawerAnimationContext();

    const animate = (toValue) => {
        animationRef.current = Animated.spring(animation, {
            toValue: toValue === 1,
            useNativeDriver: false,
            bounciness: 2,
            isInteraction: true,
            speed: 10,
        });

        return animationRef.current;
    };


    const isDrawerForceClosed = navigationService.isDrawerForceClosed;
    React.useEffect(() => {
        if (!isDrawerForceClosed) return;
        animate(0).start();
    }, [isDrawerForceClosed]);


    const onMouseOver = React.useCallback(() => {
        if (navigationService.drawerStatus === "closed") {
            navigationService.drawerStatus = "opening";
        }

        setTimeout(() => {
            if (navigationService.drawerStatus === "closed") return;
            if (navigationService.isDrawerForceClosed) return;
            navigationService.openDrawer();
            animate(1).start();
        }, 500)
            
    }, [navigationService]);


    const onMouseEnter = React.useCallback(() => {
        navigationService.drawerStatus = "opening";
        setTimeout(() => {
            if (navigationService.drawerStatus === "closed") return;
            navigationService.drawerStatus = "open";
            navigationService.openDrawer();
            animate(1).start();
        }, 500)
    }, [navigationService]);



    const onMouseLeave = React.useCallback(() => {
        navigationService.drawerStatus = "closed";
        navigationService.setForceCloseDrawer(false);
        navigationService.closeDrawer();
        animate(0).start();
    }, [navigationService]);




    React.useEffect(() => {
        if (showDrawer) { return; }
        onMouseLeave()
    }, [showDrawer]);


    const viewProps = {
        animation,
        style:{ ...drawerStyle, },
        onMouseEnter: showDrawer ? onMouseEnter : undefined,
        onMouseLeave: showDrawer ? onMouseLeave : undefined,
        onMouseOver: showDrawer ? onMouseOver : undefined,
    }


    return (
        <StyledView>
            <StyledAnimatedView { ...viewProps } >
                <DrawerContentScrollView { ...props } />
            </StyledAnimatedView>
        </StyledView>
    )
}

export default withResponsiveFlags(({isSmallScreen, ...props}) => {
    const contentContainerStyle = React.useRef({ paddingTop: 0, height: "100%" }).current;
    const Component = isSmallScreen ? DrawerContentScrollView : DrawerContent;
    return <Component {...props} height="100%" contentContainerStyle={contentContainerStyle} />
}, ["isSmallScreen"])